import { HttpLink } from 'apollo-angular-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { environment } from './../environments/environment';
export function createApollo(httpLink) {
    return {
        link: httpLink.create({ uri: environment.SAMMATHNAUR_BASE_URL }),
        cache: new InMemoryCache(),
        defaultOptions: {
            query: {
                fetchPolicy: 'no-cache',
            },
            watchQuery: {
                fetchPolicy: 'no-cache',
            }
        },
    };
}
export function createNamedApollo(httpLink) {
    return {
        mordu: {
            name: 'mordu',
            link: httpLink.create({ uri: environment.MORDU_BASE_URL }),
            cache: new InMemoryCache(),
            defaultOptions: {
                query: {
                    fetchPolicy: 'no-cache'
                }
            },
        },
    };
}
var GraphQLModule = /** @class */ (function () {
    function GraphQLModule() {
    }
    return GraphQLModule;
}());
export { GraphQLModule };
